export function downloadFile(file: File) {
	const a = document.createElement('a');
	a.href = URL.createObjectURL(file);
	a.download = file.name;
	a.click();
	URL.revokeObjectURL(a.href);
}
